import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, User } from 'lucide-react';
const builds = [{
  id: 1,
  title: "'72 Datsun 240Z",
  subtitle: 'Project Sunrise',
  owner: '@z_doctor',
  stage: 'Rust Repair',
  color: 'bg-garage-red',
  image: 'https://images.unsplash.com/photo-1552176625-e47ff529b595?auto=format&fit=crop&q=80&w=800'
}, {
  id: 2,
  title: "'89 BMW E30 M3",
  subtitle: 'Daily Warrior',
  owner: '@bavarian_beast',
  stage: 'Finished',
  color: 'bg-green-600',
  image: 'https://images.unsplash.com/photo-1617814076367-b759c7d7e738?auto=format&fit=crop&q=80&w=800'
}, {
  id: 3,
  title: "'67 Ford Mustang",
  subtitle: 'Barn Find',
  owner: '@muscle_mike',
  stage: 'Planning',
  color: 'bg-garage-accent',
  image: 'https://images.unsplash.com/photo-1532751203793-812308a10d8e?auto=format&fit=crop&q=80&w=800'
}];
export function FeaturedBuilds() {
  return <section className="py-24 bg-garage-bg" data-id="element-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-9">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-10">
          <div data-id="element-11">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-garage-text mb-4" data-id="element-12">
              FROM THE GARAGE FLOOR
            </h2>
            <p className="text-garage-muted text-lg" data-id="element-13">
              Every build has a story. Every stage matters.
            </p>
          </div>
          <a href="#" className="flex items-center gap-2 text-garage-accent hover:text-garage-accent-hover font-display font-bold uppercase tracking-wide transition-colors" data-id="element-14">
            See All Builds <ArrowRight className="w-4 h-4" data-id="element-15" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-16">
          {builds.map((build, index) => <motion.div key={build.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="group relative bg-garage-card border border-garage-border overflow-hidden" data-id="element-17">
              {/* Image Container */}
              <div className="aspect-[4/3] overflow-hidden relative" data-id="element-18">
                <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors z-10" data-id="element-19" />
                <img src={build.image} alt={build.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 grayscale group-hover:grayscale-0" data-id="element-20" />
                <div className={`absolute top-4 right-4 px-3 py-1 ${build.color} text-white text-xs font-bold uppercase tracking-wider z-20`} data-id="element-21">
                  {build.stage}
                </div>
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-22">
                <h3 className="text-2xl font-display font-bold text-garage-text mb-1" data-id="element-23">
                  {build.title}
                </h3>
                <p className="text-garage-accent font-mono text-sm mb-4" data-id="element-24">
                  {build.subtitle}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-garage-border/50" data-id="element-25">
                  <div className="flex items-center gap-2 text-garage-muted text-sm" data-id="element-26">
                    <User className="w-4 h-4" data-id="element-27" />
                    <span data-id="element-28">{build.owner}</span>
                  </div>
                  <div className="flex items-center gap-2 text-garage-muted text-sm" data-id="element-29">
                    <Clock className="w-4 h-4" data-id="element-30" />
                    <span data-id="element-31">Updated 2h ago</span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}